<template>
  <q-layout>
    <q-page-container>
      <div class="row q-pa-md">
        <div class="row col-12 bg-white q-mt-md chart-box q-pa-md filter-box">
          <div class="text-primary q-mb-sm text-h6">Filter</div>
          <q-select
            outlined
            dense
            v-model="input.mode"
            :options="['By Day', 'By Week', 'By Month']"
            class="col-12"
          ></q-select>
          <date-picker
            v-if="input.mode === 'By Day'"
            v-model="input.filter"
            value-type="date"
            placeholder="Select date range"
            class="col-12 q-pt-md"
            range
          ></date-picker>
          <date-picker
            v-if="input.mode === 'By Week'"
            :lang="lang"
            v-model="input.filter"
            type="week"
            placeholder="Select range of week"
            range
            class="col-12 q-pt-md"
          ></date-picker>
          <date-picker
            v-if="input.mode === 'By Month'"
            v-model="input.filter"
            type="month"
            range
            placeholder="Select year"
            class="col-12 q-pt-md"
          ></date-picker>
          <div class="col-12 row justify-end">
            <q-btn
              class="q-mt-md"
              label="Apply"
              no-caps
              no-wrap
              color="primary"
              @click="onApply"
            ></q-btn>
          </div>
        </div>

        <!-- <div
          class="
            row
            col-12
            bg-white
            q-mt-md
            chart-box
            q-pa-md
            text-center text-h6 text-primary
          "
        >
          {{ fomatedFilterText }}
        </div> -->

        <div class="chart-content row col-12" v-if="rawData">
          <div class="col-12 col-md-6 bg-white q-mt-md chart-box q-pa-md">
            <div class="text-primary text-h6">Sales</div>
            <bar-chart
              id="sale-chart"
              :chart-data="saleDatacollection"
              :options="saleOptions"
            ></bar-chart>
          </div>

          <div class="col-12 col-md-6 bg-white q-mt-md chart-box q-pa-md">
            <div class="text-primary text-h6">Order</div>
            <bar-chart
              id="order-chart"
              :chart-data="orderDatacollection"
              :options="orderOptions"
            ></bar-chart>
          </div>

          <div class="col-12 col-md-6 bg-white q-mt-md chart-box q-pa-md">
            <div class="text-primary text-h6">Customer</div>
            <bar-chart
              id="customer-chart"
              :chart-data="customerDatacollection"
              :options="customerOptions"
            ></bar-chart>
          </div>
        </div>

        <!-- <div class="col-12 col-md-6 bg-white q-mt-md chart-box q-pa-md">
          <div class="text-primary text-h6">Commission</div>
          <bar-chart
            id="commission-chart"
            :chart-data="commissionDatacollection"
            :options="options"
          ></bar-chart>
        </div> -->
      </div>
    </q-page-container>
  </q-layout>
</template>

<script>
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(LocalizedFormat);
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { QCard, QCardSection, QCardActions, QSelect } from "quasar";
import BarChart from "./BarChart.js";

const components = { QCard, QCardSection, QCardActions, QSelect };

export default {
  name: "SaleStat",
  components: {
    ...components,
    // LineChart,
    BarChart,
    DatePicker,
  },
  data() {
    return {
      lang: {
        formatLocale: {
          firstWeekContainsDate: 4,
        },
      },
      rawData: null,
      saleOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            title: function (tooltipItem, data) {
              return data["labels"][tooltipItem[0]["index"]];
            },
            label: function (tooltipItem, data) {
              return new Intl.NumberFormat().format(
                data["datasets"][0]["data"][tooltipItem["index"]]
              );
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "Day",
            },
          },
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Revenue (฿)",
              },
              ticks: {
                beginAtZero: true,
                min: 0,
                callback: (value, index, values) => {
                  return new Intl.NumberFormat().format(value);
                },
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Date",
              },
            },
          ],
        },
      },
      orderOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: "Day",
            },
          },
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Number of order",
              },
              ticks: {
                beginAtZero: true,
                precision: 0,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Date",
              },
            },
          ],
        },
      },
      customerOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: "Day",
            },
          },
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Number of customer",
              },
              ticks: {
                beginAtZero: true,
                precision: 0,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Date",
              },
            },
          ],
        },
      },
      input: {
        mode: "By Day",
        displayMode: null,
        filter: null,
      },
    };
  },
  computed: {
    fomatedFilterText() {
      return "test";
      // return `${this.input.filter[0].format("YYYY-MM-DD")} - ${this.input.filter[1].format("YYYY-MM-DD")}`
    },
    saleDatacollection() {
      let labels = [];
      let data = [];
      switch (this.input.displayMode) {
        case "By Day":
          labels = this.rawData.map((d) =>
            // moment(d.DateTime).format("MM/DD/YYYY")
            dayjs(d.timestamp).format("ll")
          );
          data = this.rawData.map((d) => d.totalSaleVolume);
          labels.forEach((l, index) => {
            if (index + 1 < labels.length) {
              var date1 = dayjs(labels[index]);
              var date2 = dayjs(labels[index + 1]);
              // console.log(date1.add(1, "day"), date2);
              if (!date1.add(1, "day").isSame(date2)) {
                labels.splice(index + 1, 0, date1.add(1, "day").format("ll"));
                data.splice(index + 1, 0, 0);
              }
            }
          });
          break;
        case "By Week":
          labels = this.rawData.map((d) => dayjs(d.timestamp).format("ll"));
          data = this.rawData.map((d) => d.totalSaleVolume);
          labels.forEach((l, index) => {
            if (index + 1 < labels.length) {
              var date1 = dayjs(labels[index]);
              var date2 = dayjs(labels[index + 1]);
              // console.log(date1.add(1, "week"), date2);
              if (!date1.add(1, "week").isSame(date2)) {
                labels.splice(index + 1, 0, date1.add(1, "week").format("ll"));
                data.splice(index + 1, 0, 0);
              }
            }
          });
          break;
        case "By Month":
          labels = this.rawData.map((d) =>
            dayjs(d.timestamp).format("MMM YYYY")
          );
          data = this.rawData.map((d) => d.totalSaleVolume);
          labels.forEach((l, index) => {
            if (index + 1 < labels.length) {
              var date1 = dayjs(labels[index]);
              var date2 = dayjs(labels[index + 1]);
              // console.log(date1.add(1, "month"), date2);
              if (!date1.add(1, "month").isSame(date2)) {
                labels.splice(
                  index + 1,
                  0,
                  date1.add(1, "month").format("MMM YYYY")
                );
                data.splice(index + 1, 0, 0);
              }
            }
          });
          break;
        default:
          labels = [];
          data = [];
          break;
      }

      return {
        labels: labels,
        color: [],
        datasets: [
          {
            label: "Sales",
            data: data,
            backgroundColor: "#2c2a74",
          },
        ],
      };
    },
    orderDatacollection() {
      let labels = [];
      let data = [];
      switch (this.input.displayMode) {
        case "By Day":
          labels = this.rawData.map((d) =>
            // moment(d.DateTime).format("MM/DD/YYYY")
            dayjs(d.timestamp).format("ll")
          );
          data = this.rawData.map((d) => d.totalOrder);
          labels.forEach((l, index) => {
            if (index + 1 < labels.length) {
              var date1 = dayjs(labels[index]);
              var date2 = dayjs(labels[index + 1]);
              // console.log(date1.add(1, "day"), date2);
              if (!date1.add(1, "day").isSame(date2)) {
                labels.splice(index + 1, 0, date1.add(1, "day").format("ll"));
                data.splice(index + 1, 0, 0);
              }
            }
          });
          break;
        case "By Week":
          labels = this.rawData.map((d) => dayjs(d.timestamp).format("ll"));
          data = this.rawData.map((d) => d.totalOrder);
          labels.forEach((l, index) => {
            if (index + 1 < labels.length) {
              var date1 = dayjs(labels[index]);
              var date2 = dayjs(labels[index + 1]);
              // console.log(date1.add(1, "week"), date2);
              if (!date1.add(1, "week").isSame(date2)) {
                labels.splice(index + 1, 0, date1.add(1, "week").format("ll"));
                data.splice(index + 1, 0, 0);
              }
            }
          });
          break;
        case "By Month":
          labels = this.rawData.map((d) =>
            dayjs(d.timestamp).format("MMM YYYY")
          );
          data = this.rawData.map((d) => d.totalOrder);
          labels.forEach((l, index) => {
            if (index + 1 < labels.length) {
              var date1 = dayjs(labels[index]);
              var date2 = dayjs(labels[index + 1]);
              // console.log(date1.add(1, "month"), date2);
              if (!date1.add(1, "month").isSame(date2)) {
                labels.splice(index + 1, 0, date1.add(1, "month").format("ll"));
                data.splice(index + 1, 0, 0);
              }
            }
          });
          break;
        default:
          labels = [];
          data = [];
          break;
      }

      return {
        labels: labels,
        color: [],
        datasets: [
          {
            label: "Order",
            data: data,
            backgroundColor: "#2c2a74",
          },
        ],
      };
    },
    customerDatacollection() {
      let labels = [];
      let data = [];
      switch (this.input.displayMode) {
        case "By Day":
          labels = this.rawData.map((d) =>
            // moment(d.DateTime).format("MM/DD/YYYY")
            dayjs(d.timestamp).format("ll")
          );
          data = this.rawData.map((d) => d.totalCustomer);
          labels.forEach((l, index) => {
            if (index + 1 < labels.length) {
              var date1 = dayjs(labels[index]);
              var date2 = dayjs(labels[index + 1]);
              // console.log(date1.add(1, "day"), date2);
              if (!date1.add(1, "day").isSame(date2)) {
                labels.splice(index + 1, 0, date1.add(1, "day").format("ll"));
                data.splice(index + 1, 0, 0);
              }
            }
          });
          break;
        case "By Week":
          labels = this.rawData.map((d) => dayjs(d.timestamp).format("ll"));
          data = this.rawData.map((d) => d.totalCustomer);
          labels.forEach((l, index) => {
            if (index + 1 < labels.length) {
              var date1 = dayjs(labels[index]);
              var date2 = dayjs(labels[index + 1]);
              // console.log(date1.add(1, "week"), date2);
              if (!date1.add(1, "week").isSame(date2)) {
                labels.splice(index + 1, 0, date1.add(1, "week").format("ll"));
                data.splice(index + 1, 0, 0);
              }
            }
          });
          break;
        case "By Month":
          labels = this.rawData.map((d) =>
            dayjs(d.timestamp).format("MMM YYYY")
          );
          data = this.rawData.map((d) => d.totalCustomer);
          labels.forEach((l, index) => {
            if (index + 1 < labels.length) {
              var date1 = dayjs(labels[index]);
              var date2 = dayjs(labels[index + 1]);
              // console.log(date1.add(1, "month"), date2);
              if (!date1.add(1, "month").isSame(date2)) {
                labels.splice(index + 1, 0, date1.add(1, "month").format("ll"));
                data.splice(index + 1, 0, 0);
              }
            }
          });
          break;
        default:
          labels = [];
          data = [];
          break;
      }

      return {
        labels: labels,
        color: [],
        datasets: [
          {
            label: "Customer",
            data: data,
            backgroundColor: "#2c2a74",
          },
        ],
      };
    },
    id() {
      return this.$store.getters["sale/getId"]; //Master
      // return "5cc620d7-3570-4a9c-88db-b35f4b1d3396"; //Mock
    },
  },
  created() {
    let end = dayjs();
    let start = dayjs().subtract(7, "days");
    let d_end = end.toDate();
    let d_start = start.toDate();
    d_end.setHours(0, 0, 0, 0);
    d_start.setHours(0, 0, 0, 0);
    this.input.filter = [d_start, d_end];
    console.log("created", d_start, d_end);
  },
  methods: {
    async getDaily() {
      console.log("getDaily", this.id);
      const result = await this.$services.stat.listDailyStat(
        this.id,
        this.input.filter[0],
        this.input.filter[1]
      );
      console.log(result);
      this.rawData = result;
    },
    async getWeekly() {
      const result = await this.$services.stat.listWeeklyStat(
        this.id,
        this.input.filter[0],
        this.input.filter[1]
      );
      console.log(result);
      this.rawData = result;
    },
    async getMonthly() {
      const result = await this.$services.stat.listMonthlyStat(
        this.id,
        this.input.filter[0],
        this.input.filter[1]
      );
      console.log(result);
      this.rawData = result;
    },
    onApply() {
      this.input.displayMode = this.input.mode;
      switch (this.input.displayMode) {
        case "By Day":
          this.getDaily();
          break;
        case "By Week":
          this.getWeekly();
          break;
        case "By Month":
          this.getMonthly();
          break;
        default:
          this.getDaily();
          break;
      }
    },
  },
};
</script>

<style scoped>

.chart-box {
  border-radius: 10px;
}
>>> .mx-input {
  height: 40px !important;
}

</style>
